/* unplugin-vue-components disabled */import { render } from "./PriceCalculateQuestionSelector.vue?vue&type=template&id=2b7ff8eb&scoped=true"
import script from "./PriceCalculateQuestionSelector.vue?vue&type=script&lang=js"
export * from "./PriceCalculateQuestionSelector.vue?vue&type=script&lang=js"

import "./PriceCalculateQuestionSelector.vue?vue&type=style&index=0&id=2b7ff8eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7ff8eb"]])

export default __exports__